import _typeof from "@babel/runtime/helpers/typeof";
import { ConfigurationError } from '@cian/peperrors/shared';
import * as yup from 'yup';
import { EFormFieldsNames } from '../../../../types/requestForm';
import { FIELDS_CONFIG } from '../../fieldsConfig';
import { objectFromEntries } from '../../../../utils/objectFromEntries';
import { isEnum } from '../../../../utils/isEnum';
export function createValidation(fields) {
  return yup.object().shape(objectFromEntries(fields.map(function (key) {
    return createValidationEntry(key);
  })));
}
function createValidationEntry(value) {
  var key;
  var field;
  if (_typeof(value) === 'object') {
    if (!isEnum(EFormFieldsNames)(value.name)) {
      throw new ConfigurationError({
        message: "\n          \u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u0440\u0430\u0432\u0438\u043B\u043E \u0432\u0430\u043B\u0438\u0434\u0430\u0446\u0438\u0438 \u0434\u043B\u044F \u043F\u043E\u043B\u044F \u0441 \u0438\u043C\u0435\u043D\u0435\u043C ".concat(value.name, ".\n          \u041F\u043E\u043B\u0435 \u0444\u043E\u0440\u043C\u044B \"").concat(value.name, "\" \u043D\u0435 \u0431\u044B\u043B\u043E \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u0441\u0440\u0435\u0434\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445\n          \u043F\u043E\u043B\u0435\u0439 EFormFieldsNames. \u041A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044F \u043F\u043E\u043B\u0435\u0439 \u0437\u0430\u0434\u0430\u043D\u0430 \u043D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u043E.\n        "),
        domain: 'mappers.requestForm.steps.utils.createValidationEntry'
      });
    }
    key = value.name;
    field = value;
  } else {
    key = value;
    field = FIELDS_CONFIG[key].field;
  }
  var validation = FIELDS_CONFIG[key].validation;
  if (!field.required) {
    validation = validation.optional();
  }
  return [key, validation];
}